import { SKELETON_DELAY_RESET_MS } from '../constants';

type TEntry = { start: number; lastSeen: number };
const entries = new Map<string, TEntry>();

export const getRemainingSkeletonDelay = (key: string, delayMs: number, now: number = Date.now()): number => {
    const previous = entries.get(key);
    const entry =
        previous && now - previous.lastSeen <= SKELETON_DELAY_RESET_MS ? previous : { start: now, lastSeen: now };
    entry.lastSeen = now;
    entries.set(key, entry);
    return Math.max(0, delayMs - (now - entry.start));
};

export const markSkeletonSeen = (key: string, now: number = Date.now()) => {
    const entry = entries.get(key);
    if (entry) entry.lastSeen = now;
};

export const resetSkeletonDelays = () => entries.clear();
